
import {Col, Row} from "react-bootstrap";
import PaginationComponent from "../pagination";

const Footer = (props) => {
    const {addons, totalEntities, currentLimit, currentPage, onChangePage} = props

    return (
        <Row>
            <Col className="d-flex justify-content-start align-items-center">
                {addons?.bottom?.left && <div className="me-2">
                    {addons.bottom.left}
                </div>}
                {!addons?.bottom?.left && <>Found {totalEntities} entities</>}
            </Col>
            <Col className="d-flex justify-content-end align-items-center">
                <PaginationComponent
                    totalItems={totalEntities}
                    itemPerPage={parseInt(currentLimit)}
                    paginate={page => onChangePage(page)}
                    currentPage={currentPage > 0 ? currentPage : 1}
                />
            </Col>
        </Row>
    )
}

export default Footer